import { redirect } from "next/navigation"

import { getCurrentUser } from "@/lib/auth/get-user"
import { getProfileByUserId } from "@/lib/auth/get-profile"

export async function requireAdmin() {
  const user = await getCurrentUser()

  if (!user) {
    redirect("/auth/sign-in?next=/admin")
  }

  const profile = await getProfileByUserId(user.id)

  if (!profile || profile.role !== "admin") {
    redirect("/dashboard")
  }

  return {
    user,
    profile,
  }
}